import React, { ComponentProps } from 'react'

import { Icon } from '@/shared/components'
import { faChevronDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { styled } from '@mui/material'
import { RichTreeView } from '@mui/x-tree-view/RichTreeView'

import { CustomTreeItem } from './CustomTreeItem'

export type CustomTreeProps = ComponentProps<typeof StyledRichTreeView> & {
  //
}

export const CustomTree: React.FC<CustomTreeProps> = (props) => {
  return (
    <StyledRichTreeView
      sx={{ overflow: 'hidden' }}
      slots={{
        expandIcon: () => (<StyledTreeItemIcon icon={faChevronRight} />),
        collapseIcon: () => (<StyledTreeItemIcon icon={faChevronDown} />),
        item: CustomTreeItem,
      }}
      {...props}
    />
  )
}

const StyledTreeItemIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  width: ${props => props.theme.typography.pxToRem(14)};
  height: ${props => props.theme.typography.pxToRem(14)};
  margin: 0;
`

const StyledRichTreeView = styled(RichTreeView)`
  background-color: ${props => props.theme.palette.background.paper};
`